// extracted by mini-css-extract-plugin
module.exports = {"panel":"_0fd55ca845--panel--DXzX3"};